export default __webpack_public_path__ + "static/media/SG DE upd4.189c0cfc.jpg";